/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlaygroundAgentsResponse } from '../../models/playground-agents-response';

export interface GetPlaygroundAgents$Params {
}

export function getPlaygroundAgents(http: HttpClient, rootUrl: string, params?: GetPlaygroundAgents$Params, context?: HttpContext): Observable<StrictHttpResponse<PlaygroundAgentsResponse>> {
  const rb = new RequestBuilder(rootUrl, getPlaygroundAgents.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlaygroundAgentsResponse>;
    })
  );
}

getPlaygroundAgents.PATH = '/playground/agents';
